import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.components.WorkflowWizardPopup.InitialStep', {
    title: 'Quick start wizard: build your first workflow ',
    description: 'Just answer a few questions to get a customised workflow that will supercharge your approvals.',
    button: 'Let’s start',
});
